<template>
  <el-progress
    v-if="showProgress"
    :percentage="percentage"
    :show-text="false"
  />
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted, ref } from 'vue'

import EventBus, { GlobalEvents } from '@shared/event-bus'

interface ProgressEvent {
  total?: number
  loaded: number
}

export default defineComponent({
  setup() {
    const percentage = ref(0)
    const showProgress = ref(false)

    const watchProgress = (event?: ProgressEvent) => {
      if (event && event.total) {
        showProgress.value = true

        percentage.value = Math.round((event.loaded * 100) / event.total)

        if (percentage.value === 100) {
          const timeout = window.setTimeout(() => {
            showProgress.value = false
            percentage.value = 0

            window.clearTimeout(timeout)
          }, 400)
        }
      }
    }

    onMounted(() => {
      EventBus.on(GlobalEvents.AsyncRequestProgress, watchProgress)
    })

    onUnmounted(() => {
      EventBus.off(GlobalEvents.AsyncRequestProgress, watchProgress)
    })

    return {
      percentage,
      showProgress,
    }
  },
})
</script>
